module.exports = __webpack_public_path__ + "media/images/gobble_july4th/bg-md-b6cae7e5d2911f4a007cba6382a7e52b.jpg";